import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MainComponent } from './main/main.component';
import { ConfirmComponent } from './confirm/confirm.component';
import { DirectAccessGuard } from './guard/direct-access-guard.guard';

const routes: Routes = [
  {
    path: '',
    component: MainComponent
  },
  {
    path: 'confirm',
    component: ConfirmComponent,
    canActivate: [DirectAccessGuard]
  },
  // {path: '**', redirectTo: '/', pathMatch: 'prefix'}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
